'use strict';

/**
 * @name inject
 */

exports.load = require('./load.js');
exports.loadHTML = require('./load-html.js');
exports.close = require('./close.js');
exports.show = require('./show.js');
exports.runScript = require('./run-script.js');


exports.addStopUrl = require('./add-stop-url.js');

exports.callback = require('./callback.js');
